<template>
  <div>
    <svg class="d-none">
      <g id="amount">
        <defs>
          <clipPath>
            <rect width="21.302" height="19.05" fill="none" />
          </clipPath>
        </defs>
        <g clip-path="url(#clip-path)">
          <path
            d="M18.778,12a10.639,10.639,0,0,0-4.667.967A3.22,3.22,0,0,0,12,15.622V26.467a3.2,3.2,0,0,0,2.1,2.641,10.654,10.654,0,0,0,4.674.974,11.214,11.214,0,0,0,4.053-.706,6.551,6.551,0,1,0,2.951-12.4c-.078,0-.156,0-.233.007V15.622a3.211,3.211,0,0,0-2.1-2.655A10.637,10.637,0,0,0,18.778,12Zm0,.911a9.876,9.876,0,0,1,4.279.883c1.065.532,1.6,1.21,1.6,1.829a2.677,2.677,0,0,1-1.6,1.821,9.877,9.877,0,0,1-4.279.883,9.876,9.876,0,0,1-4.279-.883,2.68,2.68,0,0,1-1.6-1.821c0-.618.538-1.3,1.6-1.829a9.877,9.877,0,0,1,4.279-.883M12.9,17.458a5.249,5.249,0,0,0,1.207.812,10.637,10.637,0,0,0,4.667.967,12.643,12.643,0,0,0,2.231-.2A6.573,6.573,0,0,0,19.739,21c-.313.027-.632.049-.96.049a9.862,9.862,0,0,1-4.272-.883c-1.063-.532-1.6-1.2-1.6-1.829Zm12.878.424a5.648,5.648,0,1,1-5.648,5.648A5.641,5.641,0,0,1,25.782,17.881ZM12.9,20.169a5.227,5.227,0,0,0,1.2.8,10.651,10.651,0,0,0,4.674.974c.221,0,.435-.01.65-.021a6.564,6.564,0,0,0-.2,1.6c0,.073,0,.147.007.219-.152.006-.3.007-.459.007a9.862,9.862,0,0,1-4.272-.883c-1.063-.531-1.6-1.2-1.6-1.828Zm0,2.711a5.227,5.227,0,0,0,1.2.8,10.651,10.651,0,0,0,4.674.974c.185,0,.37-.005.551-.014A6.5,6.5,0,0,0,19.9,26.41c-.364.036-.737.056-1.123.056a9.862,9.862,0,0,1-4.272-.883c-1.063-.531-1.6-1.2-1.6-1.828Zm0,2.711a5.227,5.227,0,0,0,1.2.8,10.651,10.651,0,0,0,4.674.974,12.88,12.88,0,0,0,1.631-.1,6.563,6.563,0,0,0,1.433,1.483,10.979,10.979,0,0,1-3.064.424,9.866,9.866,0,0,1-4.272-.883c-1.063-.531-1.6-1.2-1.6-1.828Z"
            transform="translate(-11.516 -11.516)"
            fill="currentColor"
          />
          <path
            d="M14.266,19.05a6.942,6.942,0,0,1-2.975-.663,11.848,11.848,0,0,1-4.028.663,11.186,11.186,0,0,1-4.89-1.025C.842,17.26,0,16.169,0,14.951V4.106C0,2.882.845,1.785,2.379,1.019A11.167,11.167,0,0,1,7.248,0h.013a11.174,11.174,0,0,1,4.884,1.018c1.529.765,2.371,1.861,2.371,3.088v.876a7.036,7.036,0,0,1-.251,14.068m-3.488-1.988a.484.484,0,0,1-.1.513q.238-.078.464-.166a.485.485,0,0,1,.144-.033q-.259-.144-.5-.314M14.266,6.85A5.157,5.157,0,1,0,17.92,8.36,5.132,5.132,0,0,0,14.266,6.85M1.878,15.041c.06.434.547.915,1.329,1.306a9.436,9.436,0,0,0,4.055.832,10.929,10.929,0,0,0,2.038-.19,6.966,6.966,0,0,1-.631-.719,13.741,13.741,0,0,1-1.406.07,11.183,11.183,0,0,1-4.89-1.025q-.259-.13-.494-.273m7.015.231a.484.484,0,0,1,.2.043q-.12-.187-.225-.381a.484.484,0,0,1-.213.364l.178-.021a.494.494,0,0,1,.062,0M1.878,12.329c.06.433.547.915,1.329,1.306a9.432,9.432,0,0,0,4.055.831c.137,0,.273,0,.409-.008a6.991,6.991,0,0,1-.251-.833H7.262A11.183,11.183,0,0,1,2.372,12.6q-.259-.13-.494-.273m-.91.369v1.135a.484.484,0,0,1,.544-.227A2.221,2.221,0,0,1,.968,12.7m6.975-.036a.485.485,0,0,1,.242.157q-.023-.18-.036-.361a.486.486,0,0,1-.206.2M1.878,9.618c.06.434.547.915,1.329,1.305a9.415,9.415,0,0,0,4.028.831,7.089,7.089,0,0,1,.081-.839H7.262a11.183,11.183,0,0,1-4.89-1.025q-.259-.13-.494-.272m-.91.369v1.136a.484.484,0,0,1,.544-.227,2.222,2.222,0,0,1-.544-.909M8.12,9.974a.484.484,0,0,1,.259.31q.062-.213.14-.421a.484.484,0,0,1-.253.1l-.145.012M1.879,6.91c.062.433.549.913,1.329,1.3a9.432,9.432,0,0,0,4.055.831c.221,0,.436-.011.635-.025a7.052,7.052,0,0,1,.482-.862c-.371.031-.744.047-1.117.047A11.173,11.173,0,0,1,2.379,7.187q-.262-.131-.5-.277m-.911.365V8.412a.484.484,0,0,1,.545-.226,2.222,2.222,0,0,1-.545-.91m8.669-.214a.484.484,0,0,1,.327.579A6.085,6.085,0,0,1,13.809,5.9a.484.484,0,0,1-.26-.429v-1a3.168,3.168,0,0,1-1.794,1.9,8.617,8.617,0,0,1-2.118.7M3.2,5.5a9.453,9.453,0,0,0,4.059.83,9.449,9.449,0,0,0,4.062-.831l.006,0a2.19,2.19,0,0,0,1.328-1.433c-.034-.439-.539-.951-1.333-1.348a9.448,9.448,0,0,0-4.062-.831A9.449,9.449,0,0,0,3.2,2.711c-.807.4-1.314.924-1.334,1.368C1.974,4.786,2.832,5.3,3.2,5.5M.968,4.49V5.7A.484.484,0,0,1,1.574,5.5a2.513,2.513,0,0,1-.606-1m12.175-.384h0Z"
            fill="currentColor"
          />
        </g>
      </g>
      <g id="logo" transform="translate(0 1.5)">
        <circle
          id="Ellipse_4"
          data-name="Ellipse 4"
          cx="11"
          cy="11"
          r="11"
          transform="translate(2 3)"
          fill="none"
          stroke="currentColor"
          stroke-width="4"
        />
        <circle
          id="Ellipse_5"
          data-name="Ellipse 5"
          cx="5"
          cy="5"
          r="5"
          transform="translate(15)"
          fill="currentColor"
        />
        <circle
          id="Ellipse_6"
          data-name="Ellipse 6"
          cx="5"
          cy="5"
          r="5"
          transform="translate(8 9)"
          fill="currentColor"
        />
        <text
          id="Local_Influencer"
          data-name="Local Influencer"
          transform="translate(31.973 20.5)"
          fill="currentColor"
          font-size="20"
          font-family="SegoeUIBlack, Segoe UI"
        >
          <tspan x="0" y="0">Local Influencer</tspan>
        </text>
      </g>
      <g
        id="watch_icon"
        data-name="watch icon"
        transform="translate(-0.723 -0.721)"
      >
        <path
          id="Path_102"
          data-name="Path 102"
          d="M1.245,5.221S3.236,1.243,6.722,1.243,12.2,5.221,12.2,5.221,10.208,9.2,6.722,9.2,1.245,5.221,1.245,5.221Z"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.045"
        />
        <path
          id="Path_103"
          data-name="Path 103"
          d="M6.722,6.713A1.492,1.492,0,1,0,5.228,5.221,1.492,1.492,0,0,0,6.722,6.713Z"
          fill="none"
          stroke="CurrentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.045"
        />
      </g>
      <g
        id="setting"
        data-name="Group 1345"
        transform="translate(-162.264 160.327)"
      >
        <path
          id="Path_972"
          data-name="Path 972"
          d="M175.884-135.243a11.516,11.516,0,0,1-3.605.037.83.83,0,0,1-.6-.536l-.68-2.341a1.359,1.359,0,0,0-.543-.693L167.99-140.2a1.317,1.317,0,0,0-.869-.114l-2.322.622a.815.815,0,0,1-.764-.24,11.472,11.472,0,0,1-1.724-2.966.831.831,0,0,1,.164-.788l1.746-1.821a1.361,1.361,0,0,0,.328-.817v-2.846a1.316,1.316,0,0,0-.335-.81l-1.741-1.74a.807.807,0,0,1-.171-.781,12.8,12.8,0,0,1,.751-1.506,12.775,12.775,0,0,1,.957-1.44.832.832,0,0,1,.765-.25l2.484.61a1.362,1.362,0,0,0,.872-.124l2.465-1.423a1.316,1.316,0,0,0,.534-.7l.628-2.343a.8.8,0,0,1,.591-.537,11.466,11.466,0,0,1,3.384.016.815.815,0,0,1,.59.542l.622,2.322a1.317,1.317,0,0,0,.534.7l2.465,1.423a1.317,1.317,0,0,0,.869.114l2.322-.622a.814.814,0,0,1,.764.239,11.509,11.509,0,0,1,1.772,3.084.818.818,0,0,1-.176.783l-1.634,1.633a1.316,1.316,0,0,0-.335.81v2.846a1.315,1.315,0,0,0,.335.81l1.658,1.658a.822.822,0,0,1,.178.783,12.608,12.608,0,0,1-.817,1.667,12.832,12.832,0,0,1-.957,1.441.812.812,0,0,1-.763.241l-2.206-.591a1.317,1.317,0,0,0-.869.114l-2.465,1.423a1.315,1.315,0,0,0-.534.7l-.613,2.29A.829.829,0,0,1,175.884-135.243ZM168.3-147.7A5.7,5.7,0,0,1,174-153.4a5.7,5.7,0,0,1,5.693,5.693A5.7,5.7,0,0,1,174-142.012,5.7,5.7,0,0,1,168.3-147.7Z"
          transform="translate(0 0)"
          fill="#c9ced6"
          fill-rule="evenodd"
        />
      </g>
      <g
        id="notiffication_icon"
        data-name="notiffication icon"
        transform="translate(1 1)"
      >
        <path
          id="Path_169"
          data-name="Path 169"
          d="M16,7A6,6,0,1,0,4,7c0,7-3,9-3,9H19S16,14,16,7Z"
          transform="translate(-1 -1)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <path
          id="Path_170"
          data-name="Path 170"
          d="M11.73,20a2,2,0,0,1-3.46,0"
          transform="translate(-1 -1)"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </g>
      <g
        id="notiffication_icon-2"
        data-name="notiffication icon"
        transform="translate(1 1)"
      >
        <g data-name="notiffication icon">
          <path
            id="Path_169"
            data-name="Path 169"
            d="M16,7A6,6,0,1,0,4,7c0,7-3,9-3,9H19S16,14,16,7Z"
            transform="translate(-1 -1)"
            fill="#253858"
            stroke="#253858"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Path_170"
            data-name="Path 170"
            d="M11.73,20a2,2,0,0,1-3.46,0"
            transform="translate(-1 -0.997)"
            fill="#253858"
            stroke="#253858"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </g>
      </g>
      <g id="dropdown" transform="translate(1.414 1.414)">
        <path
          id="Path_180"
          data-name="Path 180"
          d="M1,1,7,7l6-6"
          transform="translate(-1 -1)"
          fill="none"
          stroke="#c9ced6"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </g>
      <g id="Influencers">
        <path
          id="Path_213"
          data-name="Path 213"
          d="M70.366,46.3a3.38,3.38,0,0,1-2.207.808,3.467,3.467,0,0,1-2.185-.787,4.438,4.438,0,0,0-.874,1.027,6.848,6.848,0,0,1,1.792,4.042c.393.022.83.044,1.289.044a12.509,12.509,0,0,0,3.671-.5.473.473,0,0,0,.328-.481A5.893,5.893,0,0,0,70.366,46.3Z"
          transform="translate(-51.444 -41.274)"
          fill="currentColor"
        />
        <circle
          id="Ellipse_7"
          data-name="Ellipse 7"
          cx="2.36"
          cy="2.36"
          r="2.36"
          transform="translate(14.356)"
          fill="currentColor"
        />
        <path
          id="Path_214"
          data-name="Path 214"
          d="M8.784,46.3a3.389,3.389,0,0,1-2.185.787A3.467,3.467,0,0,1,4.414,46.3,5.8,5.8,0,0,0,2.6,50.43a.5.5,0,0,0,.328.481,12.645,12.645,0,0,0,3.671.5c.459,0,.9-.022,1.289-.044a6.848,6.848,0,0,1,1.792-4.042A5.128,5.128,0,0,0,8.784,46.3Z"
          transform="translate(-2.6 -41.274)"
          fill="currentColor"
        />
        <circle
          id="Ellipse_8"
          data-name="Ellipse 8"
          cx="2.36"
          cy="2.36"
          r="2.36"
          transform="translate(1.639)"
          fill="currentColor"
        />
        <path
          id="Path_215"
          data-name="Path 215"
          d="M37.884,53.2a3.428,3.428,0,0,1-4.37,0A5.893,5.893,0,0,0,31.7,57.352a.5.5,0,0,0,.328.481,13.658,13.658,0,0,0,7.342,0,.473.473,0,0,0,.328-.481A5.725,5.725,0,0,0,37.884,53.2Z"
          transform="translate(-25.342 -46.667)"
          fill="currentColor"
        />
        <circle
          id="Ellipse_9"
          data-name="Ellipse 9"
          cx="2.36"
          cy="2.36"
          r="2.36"
          transform="translate(7.997 1.508)"
          fill="currentColor"
        />
      </g>
      <g id="deal">
        <path
          id="Path_891"
          data-name="Path 891"
          d="M41.427,29.159l.154-4.025a.721.721,0,0,0-.737-.737l-4.008.171a.639.639,0,0,0-.394.171l-6.355,6.337a.634.634,0,0,0,.051.908l3.854,3.854a.649.649,0,0,0,.908.051l6.355-6.355A.55.55,0,0,0,41.427,29.159Zm-1.781-2.09a.805.805,0,1,1,.805-.805A.8.8,0,0,1,39.645,27.069Z"
          transform="translate(-29.92 -24.397)"
          fill="currentColor"
        />
        <path
          id="Path_892"
          data-name="Path 892"
          d="M41.7,65.092,36.475,70.3c-.171.223-.565.188-.908-.051L32.3,66.993l-.377.548a.651.651,0,0,0,.206.891l4.47,3.117a.645.645,0,0,0,.908-.12l4.316-6.218C41.888,65.126,41.768,65.023,41.7,65.092Z"
          transform="translate(-31.495 -58.103)"
          fill="currentColor"
        />
      </g>
      <g id="compaign">
        <path
          id="Path_212"
          data-name="Path 212"
          d="M-851.544,96.471l-1.556-1.257,1.957.412c.637.134.058,1.214-.4.845Zm-12.633-.175,4.7-5.45a.533.533,0,0,1,.121-.1l.42-1.346a.531.531,0,0,1,.957-.171l1.793,2.687a1.761,1.761,0,0,1,.962-.284,1.769,1.769,0,0,1,1.77,1.77,1.767,1.767,0,0,1-.767,1.458l1.395,2.09a.533.533,0,0,1-.449.88l-1.853-.17a.532.532,0,0,1-.237-.061l-.725.238a2.485,2.485,0,0,1-.9,3.051,2.481,2.481,0,0,1-3.8-1.507l-1.129.371a.527.527,0,0,1-.226.023,1.953,1.953,0,0,1-2.167-3.243.526.526,0,0,1,.137-.232Zm4.489-2.134a1.628,1.628,0,0,1,1.628,1.628,1.628,1.628,0,0,1-1.628,1.628,1.628,1.628,0,0,1-1.628-1.628A1.628,1.628,0,0,1-859.688,94.162Zm-3.225,4.8-.948-1.42A.893.893,0,0,0-862.914,98.964Zm5.8-.8-2.672.878a1.429,1.429,0,0,0,2.2.957,1.423,1.423,0,0,0,.475-1.835Zm-2.026-6.1-4.005,4.648,1.271,1.9,5.828-1.915-3.095-4.637Zm3.331-3.582-.31,1.976-.622-1.9C-856.938,87.94-855.713,87.9-855.8,88.483Zm2.588.788-1.257,1.556.412-1.958C-853.926,88.233-852.846,88.812-853.216,89.271Zm1.848,1.976-1.867.721,1.336-1.49c.435-.484,1.081.557.531.769Zm.612,2.635-1.977-.31,1.9-.621C-850.213,92.749-850.174,93.974-850.757,93.882Z"
          transform="translate(865.131 -88.069)"
          fill="currentColor"
          fill-rule="evenodd"
        />
      </g>
      <g id="menuIcon" transform="translate(59)">
        <rect
          id="Rectangle"
          width="44"
          height="44"
          rx="12"
          transform="translate(-59)"
          fill="#fff"
        />
        <path
          id="Path_938"
          data-name="Path 938"
          d="M-47.339,27.646h17.607"
          transform="translate(1.535 1.547)"
          fill="none"
          stroke="#253858"
          stroke-linecap="round"
          stroke-width="3"
        />
        <path
          id="Path_939"
          data-name="Path 939"
          d="M-47.339,27.646h17.607"
          transform="translate(1.535 -5.646)"
          fill="none"
          stroke="#253858"
          stroke-linecap="round"
          stroke-width="3"
        />
        <path
          id="Path_940"
          data-name="Path 940"
          d="M-47.339,27.646h17.607"
          transform="translate(1.535 -12.839)"
          fill="none"
          stroke="#253858"
          stroke-linecap="round"
          stroke-width="3"
        />
      </g>
      <g id="arrowIcon">
        <rect id="Rectangle" width="38" height="38" rx="6" fill="#fff" />
        <g data-name="Icon" transform="translate(12 12)">
          <path
            id="Path"
            d="M14,.5H0"
            transform="translate(0 6.5)"
            fill="none"
            stroke="#253858"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
          />
          <path
            id="Path-2"
            data-name="Path"
            d="M7,14,0,7,7,0"
            fill="none"
            stroke="#253858"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="2"
          />
        </g>
      </g>
      <g id="cross" transform="translate(-10.614 -10.614)">
        <path
          id="Path_891"
          data-name="Path 891"
          d="M0,13.942,13.942,0"
          transform="translate(25.971 12.029) rotate(90)"
          fill="none"
          stroke="#253858"
          stroke-linecap="round"
          stroke-width="2"
        />
        <path
          id="Path_892"
          data-name="Path 892"
          d="M0,13.942,13.942,0"
          transform="translate(25.971 25.971) rotate(180)"
          fill="none"
          stroke="#253858"
          stroke-linecap="round"
          stroke-width="2"
        />
      </g>
      <g id="trash">
        <path
          fill="currentColor"
          d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ></path>
      </g>
      <g id="profile">
        <g
          id="Group_1454"
          data-name="Group 1454"
          transform="translate(1750.51 -1858.961)"
        >
          <path
            id="Path_1457"
            data-name="Path 1457"
            d="M38.457,53.2a3.746,3.746,0,0,1-4.775,0A6.44,6.44,0,0,0,31.7,57.737a.547.547,0,0,0,.358.525,14.925,14.925,0,0,0,8.023,0,.517.517,0,0,0,.358-.525A6.256,6.256,0,0,0,38.457,53.2Z"
            transform="translate(-1782.21 1811.253)"
            fill="currentColor"
          />
          <circle
            id="Ellipse_97"
            data-name="Ellipse 97"
            cx="2.579"
            cy="2.579"
            r="2.579"
            transform="translate(-1748.719 1858.961)"
            fill="currentColor"
          />
        </g>
      </g>
      <g id="logout">
        <path
          id="Icon_open-account-logout"
          data-name="Icon open-account-logout"
          d="M4.956,0V1.652h6.608v8.26H4.956v1.652h8.26V0ZM5.3,3.3,2,5.782,5.3,8.26V6.608H9.938V4.956H5.3Z"
          transform="translate(-2)"
          fill="currentColor"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
